import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container py-3" }
const _hoisted_2 = { class: "mb-0 text-secondary text-spacing-5 py-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_AlertMessage = _resolveComponent("AlertMessage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AlertMessage, { variant: "secondary" }, {
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_2, [
          _createVNode(_component_Icon, {
            icon: _ctx.CompleteChecked,
            width: "1.2em",
            height: "1.2em",
            class: "me-2"
          }, null, 8, ["icon"]),
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mb-0 align-middle fw-bolder" }, "服務未執行或已取消", -1))
        ])
      ]),
      _: 1
    })
  ]))
}